<template>
  <div v-if="false" class="mx-10 mb-2">
    <div class="p-4 rounded-xl font-bold text-sm" style="background-color:#FF9393;">
        <div v-html="lang['components']['Plan']['Index']['stop_trade_info']"></div>
    </div>
  </div>
  <div class="lg:flex md:block sm:block rounded-xl overflow-hidden text-white px-4" style="position:relative">
    <loading :active="!this.showPlans"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="lg:w-1/4 md:w-full sm:w-full text-left sm:overflow-hidden mx-1" :style="guideStep == 1 ? { zIndex: 100, position: 'relative' } : null" style="border-right: 2px solid #E5E7EB;">
      <div class="flex-auto bg-white space-y-6 lg:p-6 md:p-6 p-4 h-full">
        <div class="text-gray-700 lg:text-xl md:text-lg text-md">{{lang['components']['Plan']['Index']['member_useing_plan_text']}}：{{ planData.plan_title }}</div>
        <div
          class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center "
          :class="{ 'plan-free': planData.plan_free, 'plan-a': planData.plan_a, 'plan-b': planData.plan_b, 'plan-c': planData.plan_c, 'plan-o': planData.plan_o }"
        >
          <div class="text-white">
            <p class="lg:text-3xl md:text-xl text-lg">{{ planData.plan_amount }}<span v-if="planData.is_amount" class="text-sm ml-2">/{{lang['components']['Plan']['Index']['time_unit']}}</span></p>
            <!--<p v-if="planData.is_amount" class="text-sm">per month</p>-->
          </div>
        </div>
        <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400">
          <li v-for="(item, index) in planData.plan_description" class="border-b">
              <div v-html="item"></div>
          </li>
        </ul>
        <div class="text-gray-700 text-left flex flex-col">
          <label class="leading-7">
            {{lang['components']['Plan']['Index']['account_use_status']}}
            <i v-if="!connectionCardData && source == 10" class="pi pi-wallet ml-1 text-xl text-red-600 cursor-pointer" v-tooltip.top="lang['components']['Plan']['Index']['new_discount']" @click="classDiscount"></i>
          </label>
          <span class="text-blue-500 text-base font-bold">{{lang['components']['Plan']['Index']['use_status'][userStatus]}}</span>
        </div>
        <div class="text-gray-700 text-left flex flex-col">
          <div>
            <label>{{lang['components']['Plan']['Index']['member_expire_time']}}</label>
            <span v-if="isPay == true" class="border-2 rounded-xl bg-blue-500 border-blue-500 text-white text-sm px-2 ml-2">{{lang['components']['Plan']['Index']['member_pay_tag']}}</span>
          </div>
          <span class="text-blue-500 text-base font-bold">{{ planData.expire_time }}</span>
        </div>
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-2 mx-auto text-gray-400 transition duration-500 ease-in-out mt-32 border-2"
          @click="showRecordModal=true">{{lang['components']['Plan']['Index']['payment_record_button_text']}}</button>
      </div>
    </div>
    <div class="lg:w-3/4 md:w-full sm:w-full sm:rounded-xl sm:overflow-hidden mx-1">
      <div class="px-4 py-5 bg-white space-y-6 lg:p-6 md:p-6 p-4">
        <div class="text-gray-700 text-xl align-bottom">
          {{lang['components']['Plan']['Index']['other_plan_list_text']}}<span class="text-sm ml-4">{{lang['components']['Plan']['Index']['pay_unit_text']}}：{{planData.label_unit}}</span>

          <span v-if="isExpiredData">
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="ml-8 inline"
            >
              <path
                d="M1.78472 14.256H14.234C14.5242 14.254 14.8094 14.181 15.0649 14.0434C15.3204 13.9058 15.5383 13.7077 15.6997 13.4666C15.861 13.2254 15.9609 12.9484 15.9906 12.6598C16.0204 12.3711 15.979 12.0796 15.8702 11.8106L9.55663 0.917472C9.40283 0.639495 9.17738 0.407789 8.90371 0.246443C8.63005 0.0850966 8.31816 0 8.00047 0C7.68278 0 7.37089 0.0850966 7.09723 0.246443C6.82356 0.407789 6.59811 0.639495 6.44431 0.917472L0.130741 11.8106C0.0239804 12.0734 -0.0183545 12.358 0.00727052 12.6405C0.0328956 12.9231 0.125737 13.1954 0.278044 13.4347C0.43035 13.674 0.637703 13.8735 0.88279 14.0163C1.12788 14.1592 1.40359 14.2414 1.6869 14.256"
                fill="red"
              />
              <path
                d="M8.00977 5.36377V8.03147M8.00977 10.6992V10.7081"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span v-if="isExpiredData && ((usePlanIdData == 1 && connectionCardData) || (usePlanIdData == 1 && !connectionCardData) || (usePlanIdData > 1 && !connectionCardData))" class="ml-2 text-sm text-red-500">
              1{{lang['components']['Plan']['Index']['is_not_expired']}}
            </span>
            <span v-if="connectionCardData && usePlanIdData > 1" class="ml-2 text-sm text-red-500">
              2{{lang['components']['Plan']['Index']['payment_error_info_text']}}
            </span>
          </span>
          <span v-if="bombmyDiscount" class="ml-2 text-sm text-red-500">{{lang['components']['Plan']['Index']['bombmy_discount_info']}}</span>
        </div>
        <!-- <div class="lg:flex md:block sm:block items-center justify-center space-y-8 lg:-mx-4 lg:flex-row lg:items-stretch lg:space-y-0"> -->
        <div>
          <div class="lg:flex md:block sm:block items-center space-y-8 lg:-mx-4 pl-2 lg:flex-row lg:items-stretch lg:space-y-0 min-w-0 whitespace-nowrap">
            <PlanA v-bind:lang="lang" v-bind:plansListA="plansListA" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanB v-bind:lang="lang" v-bind:plansListB="plansListB" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanC v-bind:lang="lang" v-bind:plansListC="plansListC" v-bind:isExpired="isExpiredData" v-bind:useFbCustomize="useFbCustomize" :handleChickPlan="handleChickPlan" :expCustomize="expCustomize" />
            <PlanO v-bind:lang="lang" v-bind:plansListO="plansListO" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
          </div>
        </div>
      </div>
    </div>
    <ChangePlanDialogEcpay v-bind:lang="lang" v-bind:planCheck="plansCheck" v-bind:bannerColor="'fb'" v-bind:borderStyle="borderStyle" v-bind:memberId="memberId" v-model:show="showPlanModal" />
    <PayRecordDialog v-bind:lang="lang" v-bind:plansList="payListData" v-bind:userStatus="userStatus" v-model:show="showRecordModal" />
    <div v-if="guideStep == 1" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
    <form id="class_plan_form" target="class_plan_form_open" method="post" action="https://test.autoturn.net/inside/udnapi/account_info/create_hidden_data_v3.php">
      <input type="hidden" id="class_member_id" name="member_id" :value="memberId">
      <input type="hidden" id="class_currency" name="currency" :value="currency">
      <input type="hidden" id="class_price" name="price" :value="PeriodAmount">
      <input type="hidden" id="class_plan_title" name="plan_title" :value="title">
      <input type="hidden" id="class_plan_id" name="plan_id" :value="planId">
      <input type="hidden" id="class_hash" name="hash" :value="this.$route.params.id">
    </form>
  </div>
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import PlanA from './PlanA'
import PlanB from './PlanB'
import PlanC from './PlanC'
import PlanO from './PlanO'
import ChangePlanDialogEcpay from '@/components/Dialog/ChangePlanDialogEcpay.vue'
import PayRecordDialog from '@/components/Dialog/PayRecordDialog.vue'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'Plan',
  props:{
    guideStep: {
      type: Number,
      default: -1
    },
    plan:{           //这个就是父组件中子标签自定义名字
      type:Object,
      // type:String,
      required:true
    },
    payList:{           //这个就是父组件中子标签自定义名字
      type:Object,
      // type:String,
      // required:true,
    },
    userStatus: {
      type: String,
      default: null
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    connectionCard: {
      type: Boolean
    },
    usePlanId: {
      type: Number
    },
    memberId: {
      type: Number
    },
    showPlans: {
      type: Boolean
    },
    transmitFbNum: {
      type: String
    },
    transmitTiktokNum: {
      type: String
    },
    source:{
      type: Number
    },
    borderStyle: {
      type: Number
    },
    useFbCustomize: {
      type: Boolean
    },
    // test:{           //这个就是父组件中子标签自定义名字
    //   type:Object,
    //   // type:String,
    //   required:true,
    //   default() {
    //     return { message: 'hello' }
    //   }
    // }
  },
  // props: ['btnName'],
  components: {
    PlanA,
    PlanB,
    PlanC,
    PlanO,
    ChangePlanDialogEcpay,
    PayRecordDialog,
    Loading
  },
  data() {
    return {
      test: ["試用15天","1個 行銷活動可使用"],
      showPlanModal: false,
      showRecordModal: false,
      selectPlan: null,
      changeCreditCard: false,
      bombmyDiscount: false,
      formActive: null,
      CardID: null,
      ClientRedirectURL: null,
      MerchantID: null,
      MerchantMemberID: null,
      MerchantTradeDate: null,
      MerchantTradeNo: null,
      ServerReplyURL: null,
      stage: null,
      TotalAmount: null,
      TradeDesc: null,
      CheckMacValue: null,
      plansListA:{
                    plan_a_title:null,
                    plan_a_amount:null,
                    plan_a_description:null,
                    plan_a_disable:null,
                    plan_a_text:null,
                    plan_a_show:null,
                    planHaveBind:false,
                  },
      plansListB:{
                    plan_b_title:null,
                    plan_b_amount:null,
                    plan_b_description:null,
                    plan_b_disable:null,
                    plan_b_text:null,
                    plan_b_show:null,
                    planHaveBind:false,
                  },
      plansListC:{
                    plan_c_title:null,
                    plan_c_amount:null,
                    plan_c_description:null,
                    plan_c_disable:null,
                    plan_c_text:null,
                    plan_c_show:null,
                    planHaveBind:false,
                  },
      plansListO:{
                    plan_id:null,
                    plan_o_title:null,
                    plan_o_amount:null,
                    plan_o_description:null,
                    plan_o_disable:null,
                    plan_o_text:null,
                    plan_o_show:null,
                    planHaveBind:false,
                    is_amount:true,
                  },
      payError: true,
      isPay: false,
      plansCheck:{
                    title : null,
                    currency : null,
                    PeriodAmount : null,
                    description : null,
                    expire_time : null,
                    card_no : null,
                    haveBind : null,
                  },
      currency: null,
      PeriodAmount: null,
      title: null,
      planId: null
    }
  },
  created() {
    axios
      .post('https://test.autoturn.net/inside/api/plan_dev_01.php', Qs.stringify({
        s_code: this.$route.params.id,
        type: 'fb'
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let aDescription = [];
          let tmpADescription = JSON.parse(response.data.plan_a_description);
          for(let i = 0; i < tmpADescription.length; i++){
            aDescription.push(tmpADescription[i]);
          }

          this.plansListA = {
                                plan_a_title : response.data.plan_a_title,
                                plan_a_amount : response.data.plan_a_amount,
                                plan_a_label_amount : response.data.plan_a_label_amount,
                                plan_a_description : aDescription,
                                plan_a_disable : response.data.plan_a_disable,
                                plan_a_text : response.data.plan_a_text,
                                plan_a_show : response.data.plan_a_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let bDescription = [];
          let tmpBDescription = JSON.parse(response.data.plan_b_description);
          for(let i = 0; i < tmpBDescription.length; i++){
            bDescription.push(tmpBDescription[i]);
          }

          this.plansListB = {
                                plan_b_title : response.data.plan_b_title,
                                plan_b_amount : response.data.plan_b_amount,
                                plan_b_label_amount : response.data.plan_b_label_amount,
                                plan_b_description : bDescription,
                                plan_b_disable : response.data.plan_b_disable,
                                plan_b_text : response.data.plan_b_text,
                                plan_b_show : response.data.plan_b_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let cDescription = [];
          let tmpCDescription = JSON.parse(response.data.plan_c_description);
          for(let i = 0; i < tmpCDescription.length; i++){
            cDescription.push(tmpCDescription[i]);
          }

          this.plansListC = {
                                plan_c_title : response.data.plan_c_title,
                                plan_c_amount : response.data.plan_c_amount,
                                plan_c_label_amount : response.data.plan_c_label_amount,
                                plan_c_description : cDescription,
                                plan_c_disable : response.data.plan_c_disable,
                                plan_c_text : response.data.plan_c_text,
                                plan_c_show : response.data.plan_c_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let oDescription = [];
          let tmpODescription = JSON.parse(response.data.plan_o_description);
          for(let i = 0; i < tmpODescription.length; i++){
            oDescription.push(tmpODescription[i]);
          }

          this.plansListO = {
                                plan_id: response.data.plan_id,
                                plan_o_title : response.data.plan_o_title,
                                plan_o_amount : response.data.plan_o_amount,
                                plan_o_label_amount : response.data.plan_o_label_amount,
                                plan_o_description : oDescription,
                                plan_o_disable : response.data.plan_o_disable,
                                plan_o_text : response.data.plan_o_text,
                                plan_o_show : response.data.plan_o_show,
                                planHaveBind: response.data.planHaveBind,
                                is_amount: response.data.is_amount,
                              }

          if(response.data.plan_id > 1){
            this.isPay = true
          }

          this.bombmyDiscount = response.data.bombmy_discount;

          console.log('this.bombmyDiscount');
          console.log(this.bombmyDiscount);
          console.log('this.plansListA');
          console.log(this.plansListA);
          console.log('this.plansListB');
          console.log(this.plansListB);
          console.log('this.plansListC');
          console.log(this.plansListC);
        } else {
          // console.log('created plan index logout');
          // window.location.href = "https://test.autoturn.net/inside/index.php/login/view";
        }
      });
  },
  watch:{
    'userStatus': function(v){
      console.log('watch userStatus');
      console.log(v);
      console.log('watch this.lang');
      console.log(this.lang);
    }
  },
  methods: {
    handleChickPlan(plan, view, active, type) {
      console.log('plan:'+plan);
      console.log('view:'+view);
      this.showPlanModal = true
      this.selectPlan = plan

      let payAgain = false;
      if(active == 'payAgain'){
        payAgain = true;
      }

      axios
      .post('https://test.autoturn.net/inside/api/plan_check.php', Qs.stringify({
        s_code: this.$route.params.id,
        plan_id: this.selectPlan,
        data_type: view,
        type: type
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let description = [];
          let tmpDescription = JSON.parse(response.data.description);
          for(let i = 0; i < tmpDescription.length; i++){
            description.push(tmpDescription[i]);
          }

          this.plansCheck = {
                              title : response.data.title,
                              currency : response.data.currency,
                              label_currency : response.data.label_currency,
                              PeriodAmount : response.data.PeriodAmount,
                              label_PeriodAmount : response.data.label_PeriodAmount,
                              description : description,
                              expire_time : response.data.expire_time,
                              card_no : response.data.card_no,
                              haveBind : response.data.haveBind,
                              memberId : response.data.memberId,
                              planId : plan,
                              payStatus: response.data.payStatus,
                              payAgain: payAgain,
                              plan_type: view,
                              check_plan_id: plan,
                              use_plan_id: this.usePlanIdData,
                              is_expired: this.isExpiredData,
                              plan_type: view
                            }

          console.log('this.plansCheck');
          console.log(this.plansCheck);
        } else {
          // console.log('handleChickPlan plan index logout');
          // window.location.href = "https://test.autoturn.net/inside/index.php/login/view";
        }
      });
    },
    expCustomize(){
      console.log('expCustomize');

      Swal.fire({
        title: 'Autoturn Plus方案 - 流程體驗',
        html: '申請完成後，您將享有 <span style="color: #FF0000;">14 天</span>自由體驗自定義設定的時間，但<span style="color: #FF0000;">在體驗期間，無法發布自定義活動，且每位用戶只能申請一次體驗</span>，請問您要申請體驗自定義功能嗎？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '我要申請',
        cancelButtonText: '我再想想',
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post('https://test.autoturn.net/inside/api/customize/data/experience_customize_create.php', Qs.stringify({
              s_code: this.$route.params.id,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                Swal.fire(
                  'Autoturn Plus方案 - 流程體驗',
                  response.data.info,
                  response.data.status
                );

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

                this.$emit('canUseFbCustomize', get_value);
              } else {
                Swal.fire(
                  'Autoturn Plus方案 - 流程體驗',
                  response.data.info,
                  response.data.status
                );
              }
            });
        }
      });
    },
    planPayAgain(plan) {
      // console.log('plan:'+plan);
      this.showPlanModal = true
      this.selectPlan = plan

      axios
      .post('https://test.autoturn.net/inside/api/plan_check.php', Qs.stringify({
        s_code: this.$route.params.id,
        plan_id: this.selectPlan
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let description = [];
          let tmpDescription = JSON.parse(response.data.description);
          for(let i = 0; i < tmpDescription.length; i++){
            description.push(tmpDescription[i]);
          }

          this.plansCheck = {
                              title : response.data.title,
                              currency : response.data.currency,
                              PeriodAmount : response.data.PeriodAmount,
                              description : description,
                              expire_time : response.data.expire_time,
                              card_no : response.data.card_no,
                              haveBind : response.data.haveBind,
                              memberId : response.data.memberId,
                              planId : plan,
                              payStatus: response.data.payStatus,
                            }
        } else {
          // console.log('handleChickPlan plan index logout');
          // window.location.href = "https://test.autoturn.net/inside/index.php/login/view";
        }
      });
    },
    classDiscount(){
      console.log('classDiscount');
      console.log(this.memberId);

      axios
        .post('https://test.autoturn.net/inside/api/class_discount_check.php', Qs.stringify({
          s_code: this.$route.params.id,
          source: this.source,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.currency = response.data.currency;
            this.PeriodAmount = response.data.period_amount;
            this.title = response.data.title;
            this.planId = response.data.plan_id;

            Swal.fire({
              title: this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_title'],
              html: this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_text'],
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.lang['components']['Plan']['Index']['methods']['classDiscount']['confirm_button_text'],
              cancelButtonText: this.lang['components']['Plan']['Index']['methods']['classDiscount']['cancel_button_text'],
            }).then((result) => {
              if (result.isConfirmed) {
                // console.log(this.$route.params.id);
                // 開啟綠界刷卡小視窗
                var iHeight = 700;
                var iWidth = 1200;
                //获得窗口的垂直位置
                var iTop = (window.screen.availHeight - 30 - iHeight) / 2;
                //获得窗口的水平位置
                var iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
                var windowStyle = 'height=' + iHeight + ',innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=no,titlebar=no';

                var newWindow = window.open('', 'class_plan_form_open',windowStyle);
                document.getElementById('class_plan_form').submit();

                let hash = this.$route.params.id;
                let urlType = this.$route.params.type;

                var timer = setInterval(function() {
                  console.log('newWindow:', newWindow);
                  // console.log(timer);
                  if(newWindow.closed) {
                    console.log('已關閉');
                    clearInterval(timer);
                    window.location.href = "https://dev-private.autoturn.net/"+urlType+'/'+hash;
                  }
                }, 1000);
              }
            });
          } else {
            Swal.fire(
              this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_title'],
              response.data.info,
              response.data.status
            );
          }
        });
    }
  },
  computed: {
    planData: {
      get: function () {
        return this.plan
      },
      set: function (value) {
        this.$emit('update:planData', value)
      }
    },
    payListData: {
      get: function () {
        return this.payList
      },
      set: function (value) {
        this.$emit('update:payList', value)
      }
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      }
    },
    connectionCardData: {
      get: function () {
        return this.connectionCard
      },
      set: function (value) {
        this.$emit('update:connectionCardData', value)
      }
    },
    usePlanIdData: {
      get: function () {
        return this.usePlanId
      },
      set: function (value) {
        this.$emit('update:usePlanIdData', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>